module.exports = __webpack_public_path__ + "static/media/ju2.44e86de3.jpg";